import { venueDecoder } from '@/common/VenueDecoder';
import { brandDecoder } from '@/common/BrandDecoder';
import {eventPerformed  } from '@/common/eventDateUtils';
import {localityDecoder} from '@/common/LocalityDecoder';

export function eventSchemaGenerator(event) {


  const SITE_BASE = 'https://www.tulum.party';
  let venue = venueDecoder(event.title);
  let brand = brandDecoder(event.title);
  let locality = localityDecoder(event.title);



  function eventPerformer() {
    return event.title.split("@")[0].split("|")[0]
  }

  function cleanContent() {

    return event.content &&
    event.content.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/gi, ' ').substr(0, 250) +
    '&hellip;'
  }


  function eventOrganizer() {
    return brand.name || venue.name
  }

  function eventOrganizerSite() {
     if(brand.name) {
      return brand.slug ? `${SITE_BASE}/brands/` + brand.slug : null;
    }
    if(venue.name) {
      return venue.slug ? `${SITE_BASE}` + venue.slug : null;
    }
  }

  function eventDateNTime() {
      return event.metadata.date &&
      event.metadata.date +
      'T' +
      event.metadata.start_time +
      '-05:00'
  }

  function eventStatus() {
    return eventPerformed(eventDateNTime())  ? "https://schema.org/EventPerformed" : "https://schema.org/EventScheduled"
  }

  function eventAvailability() {
    return eventPerformed(eventDateNTime())  ? "https://schema.org/SoldOut" : "https://schema.org/InStock"
  }

  function location() {

    if(!venue) {
      venue = {};
      return {};
    }
    return {
        "@type": "NightClub",
        "name": venue.name,
        "url":  venue.slug && (SITE_BASE + venue.slug),
        "address": {
          "@type": "PostalAddress",
          "streetAddress": venue?.directions?.address, // REQUIRED - Extracted from text
          "addressLocality": locality, // REQUIRED - Extracted from text
          "postalCode": venue?.directions?.postalCode, // REQUIRED - Extracted from text
          "addressRegion": venue?.directions?.addressRegion, // REQUIRED - Extracted from text (Quintana Roo)
          "addressCountry": "MX"
        }
      }
  }




  return {
    "@context": "https://schema.org",
    "@id": `https://www.tulum.party/event/${event.slug}#event`,
    "@type": "MusicEvent",
    "name": event.title,
    "startDate": eventDateNTime(),
    "doorTime": eventDateNTime(),
    "url": `https://www.tulum.party/event/${event.slug}`,
    "eventStatus": eventStatus( ),
    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
    "image": [
      event.metadata.main_image.imgix_url
    ],
    "location": location(),
    "description": cleanContent(),
    "offers": {
      "@type": "Offer",
      "url": `${SITE_BASE}/${event.slug}`, // Ticket link URL
      "availability":  eventAvailability()
    },
    "performer": { // Recommended - Extracted from event details
      "@type": "Person", // Or PerformingGroup if appropriate
      "name": eventPerformer(),
    },
    "organizer": { // Recommended - Extracted from event details/links
      "@type": "Organization",
      "name": eventOrganizer(),
      "url":  eventOrganizerSite(), // Optional: Add organizer URL if available
    }
  }

}

